export const FM_SOURCE_LABELS = Object.freeze({
    "1": "Payjoy",
    "2": "MovilesPay",
    "3": "Efectiva",
    "4": "CrediSmart",
    "5": "Alo Credit",
});

export const getFmSourceLabel = (source) => {
    const key = String(source ?? "").trim();
    return FM_SOURCE_LABELS[key] || "Sin fuente";
};
